/**
 * Registro de erros desta sessão (Configurações → Solução de problemas → "Baixar o
 * registro"): guarda os últimos erros da página para a pessoa mandar a quem
 * cuida do servidor. Fica só na memória do navegador.
 */
const MAX = 300;
const entries: string[] = [];

function push(kind: string, detail: string): void {
  entries.push(`${new Date().toISOString()} [${kind}] ${detail}`);
  if (entries.length > MAX) entries.shift();
}

export function installErrorLog(): void {
  window.addEventListener('error', (e) => push('erro', `${e.message} (${e.filename}:${e.lineno}:${e.colno})`));
  window.addEventListener('unhandledrejection', (e) => push('promessa', e.reason instanceof Error ? `${e.reason.message}\n${e.reason.stack ?? ''}` : String(e.reason)));
  const original = console.error.bind(console);
  console.error = (...args: unknown[]) => {
    push('console', args.map((a) => (a instanceof Error ? `${a.message}\n${a.stack ?? ''}` : typeof a === 'string' ? a : safeJson(a))).join(' '));
    original(...args);
  };
}

function safeJson(v: unknown): string {
  try {
    return JSON.stringify(v);
  } catch {
    return String(v);
  }
}

export function errorLogSize(): number {
  return entries.length;
}

/** Baixa o registro como texto. */
export function downloadErrorLog(): void {
  const header = `RPG Desk — registro de erros\n${new Date().toString()}\n${navigator.userAgent}\n\n`;
  const blob = new Blob([header + (entries.length ? entries.join('\n') : '(nenhum erro registrado nesta sessão)') + '\n'], { type: 'text/plain' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `rpgdesk-erros-${new Date().toISOString().slice(0, 19).replace(/[:T]/g, '-')}.txt`;
  document.body.append(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
